import React from "react";
import styled from "styled-components";
import { StyledSkeleton } from "components/StyledSkeleton";
import { isUndefined } from "utils/index";

const StyledP = styled.p`
  margin: 0;
  word-break: break-word;
`;

const InlineBlockSpan = styled.span`
  display: inline-block;
`;

interface IDescription {
  escrowType: string;
  deliverableText: string;
  receivingQuantity: string;
  receivingToken: string;
  buyerAddress: string;
  sendingQuantity: string;
  sendingToken: string;
  sellerAddress: string;
  deadline: number;
  assetSymbol: string;
  buyer: string;
}

const Description: React.FC<IDescription> = ({
  escrowType,
  deliverableText,
  receivingQuantity,
  receivingToken,
  buyerAddress,
  sendingQuantity,
  sendingToken,
  sellerAddress,
  deadline,
  assetSymbol,
}) => {
  const generalEscrowSummary = (
    <>
      By Paying {sendingQuantity}{" "}
      <InlineBlockSpan>{assetSymbol ? assetSymbol : <StyledSkeleton width={30} />}</InlineBlockSpan>, address{" "}
      {buyerAddress} should receive "{deliverableText}" from address {sellerAddress} before the delivery deadline{" "}
      {new Date(deadline).toString()}.
    </>
  );

  const cryptoSwapSummary = (
    <>
      By Paying {sendingQuantity} {sendingToken}, [Blockchain] address {buyerAddress} should receive {receivingQuantity}{" "}
      {receivingToken} at the [Blockchain] address {sellerAddress} from [Blockchain] address TODO before the delivery
      deadline {new Date(deadline).toString()}.
    </>
  );

  return isUndefined(deliverableText) ? (
    <StyledSkeleton />
  ) : (
    <div>
      <StyledP>{escrowType === "general" ? generalEscrowSummary : cryptoSwapSummary}</StyledP>
      <br />
      <StyledP>
        After the delivery deadline, you can start a complaint (propose a settlement or raise a dispute). In case of a
        dispute, it will be arbitrated by the Kleros Freelancing Court.
      </StyledP>
    </div>
  );
};

export default Description;
